import React, { useEffect } from 'react';
import { Button, Typography, Box, LayoutContent, LayoutContentCenter, LayoutControls, ContentFrame, } from '@pinwheel/origami';
import { useSelector } from 'react-redux';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import QuestionMarkCircle from '../../assets/QuestionMarkCircle';
import { useAppDispatch, useAppSelector } from '../../state';
import eventQueue from '../../events/queue';
import { selectExperiments, selectLinkTokenPayload, } from '../../state/slices/slice-link-params';
import { showBottomSheet } from '../../state/slices/slice-bottom-sheet';
import { tokenHasPlatform } from '../../utils';
export default function NoResults() {
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var dispatch = useAppDispatch();
    var experiments = useSelector(selectExperiments);
    var linkTokenPayload = useAppSelector(selectLinkTokenPayload);
    useEffect(function () {
        if (tokenHasPlatform(linkTokenPayload)) {
            navigate('/link-api/login');
        }
        else if (experiments.eligibilityCheckNoMatchNoPopup === 'no-popup') {
            navigate('/search/search');
        }
        else {
            var eventId = 'lookupFailed';
            eventQueue.emit('bottom_sheet', { eventId: eventId, isOpen: true });
            dispatch(showBottomSheet({
                title: getLocalizedString('WHO_PAYS_YOU'),
                body: getLocalizedString('MULTI_SUPPLIER_ELIGIBILITY_NO_MATCH'),
                dismissButtonText: getLocalizedString('LETS_DO_IT'),
                imageId: 'BigStatusIcon-search',
                eventId: eventId,
            }));
            navigate('/search/search');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // TODO: refactor this component since the content below is never rendered,
    //       the useEffect block above will always result in a navigation.
    return (React.createElement(ContentFrame, null,
        React.createElement(LayoutContent, null,
            React.createElement(LayoutContentCenter, null,
                React.createElement(Box, null,
                    React.createElement(QuestionMarkCircle, { size: 81 })),
                React.createElement(Box, null,
                    React.createElement(Typography, { as: "h2", variant: "header", color: "title", align: "center" }, getLocalizedString('MS_ELIGIBILITY_NO_RESULTS_TITLE'))),
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "body", align: "center" }, getLocalizedString('MS_ELIGIBILITY_NO_RESULTS_DESCRIPTION'))))),
        React.createElement(LayoutControls, null,
            React.createElement(Button, { eventId: "MSE-continueNoResults", onClick: function () { return navigate('/search/search'); } }, getLocalizedString('MS_ELIGIBILITY_NO_RESULTS_CONTINUE')))));
}
